import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map, of, switchMap } from 'rxjs';

import { ModalConfirmacaoComponent } from '../components/redesign/modal-confirmacao/modal-confirmacao.component';
import { AtendimentoService } from './atendimento.service';
import { MsgService } from './msg.service';
import { SessaoService } from './sessao.service';

@Injectable({ providedIn: 'root' })
export class ChatAcoesContatoService {

  private readonly dialog = inject(MatDialog);
  private readonly atendimentoService = inject(AtendimentoService);
  private readonly msgService = inject(MsgService);
  private readonly sessaoService = inject(SessaoService);

  encerrarAtendimento(contatoId: number, nomeContato?: string): Observable<boolean> {
    return this.dialog.open(ModalConfirmacaoComponent, {
      data: {
        titulo: 'Encerrar atendimento',
        texto: `Deseja encerrar o atendimento de ${nomeContato || 'este contato'}?`,
        labelConfirmar: 'Encerrar'
      }
    }).afterClosed().pipe(
      switchMap(confirmou => confirmou
        ? this.atendimentoService.encerrarAtendimentoContatoId(contatoId).pipe(map(() => {
            this.msgService.msgSucesso(`Atendimento do contato ${nomeContato ?? ''} encerrado com sucesso.`);
            return true;
          }))
        : of(false))
    );
  }

  encerrarSessao(sessaoId: number, nomeContato?: string): Observable<boolean> {
    return this.dialog.open(ModalConfirmacaoComponent, {
      data: {
        titulo: 'Encerrar sessão',
        texto: `Deseja encerrar a sessão de ${nomeContato || 'este contato'}? O atendimento em andamento também será encerrado.`,
        labelConfirmar: 'Encerrar'
      }
    }).afterClosed().pipe(
      switchMap(confirmou => confirmou
        ? this.sessaoService.inativarSessao(sessaoId).pipe(map(() => {
            this.msgService.msgSucesso(`Sessão do contato ${nomeContato ?? ''} encerrada com sucesso.`);
            return true;
          }))
        : of(false))
    );
  }
}
